import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Grid, IconButton, Tooltip, tooltipClasses, Typography, useTheme } from "@mui/material"
import { TableBasePaginado, TableLoadingComponent } from "../../components"
import FechaFunction from "../../function/FechaFunction";
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import { styled } from '@mui/material/styles';
import TratoService from "../../services/tratos.service";
import ContentPasteGoIcon from '@mui/icons-material/ContentPasteGo';

const DynamicTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.mode === 'dark' ? '#2d3a52' : theme.palette.common.white,
        color: theme.palette.mode === 'dark' ? '#e0e0e0' : 'rgba(0, 0, 0, 0.87)',
        border: theme.palette.mode === 'dark' ? '1px solid #3d4a62' : 'none',
        boxShadow: theme.shadows[1],
        fontSize: 12,
    },
}));
const PreServiciosScreen = () => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(20);
    const [count, setCount] = useState(0);
    const navigate = useNavigate();

    const actualizar = async (nroPagina = 1, limite = rowsPerPage) => {
        setLoading(true);
        await TratoService.getAll({
            type: 'multi',
            page: nroPagina,
            limit: limite
        }).then((r)=>{
            setItems(r?.data ?? r);
            setCount(r?.total ?? (r?.data ?? r)?.length ?? 0);
        }).finally(()=>setLoading(false));
    };

    const onChangePage = (nuevaPagina) => {
        setPage(nuevaPagina);
        actualizar(nuevaPagina + 1, rowsPerPage);
    };

    const onChangeRowsPerPage = (nuevoLimite) => {
        setRowsPerPage(nuevoLimite);
        setPage(0);
        actualizar(1, nuevoLimite);
    };

    const onOpenVer = (idCliente) => {
        const item = items.find((it)=> it.id_t === idCliente)
        switch (item?.empresa_t) {
            case 'NUBICOM':
                navigate(`/pre-servicio/${item.id_t}/nubicom`);
                break;
            case 'STRONG':
                navigate(`/pre-servicio/${item.id_t}/strong`);
                break;
            case 'IDS':
                navigate(`/pre-servicio/${item.id_t}/ids`);
                break;
            default:
                navigate(`/pre-servicio/${item.id_t}/nubicom`);
                break;
        }
    }

    const columns = [
        {
            name: "id_t",
            label: "ID",
            options: {
                filter: true,
                sort: true,
                display:true,
                viewColumns: true
            }
        },
        {
            name: "createdAt",
            label: "Registrado",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    return FechaFunction.format(value,'dd/MM/yyyy');
                }
            }
        },
        {
            label: "Nombre",
            name: "nombre_t",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: 'direccion_t',
            label: "Direccion"
        },
        {
            name: 'estadoServicio_t',
            label: "Estado"
        },
        {
            name: 'tratoserv',
            label: "Plan",
            options: {
                filter: false,
                sort: false,
                customBodyRender: (value) => value?.[0]?.nombreServicio_ds || 'Sin Plan'
            }
        },
        {
            name: 'actions',
            label: "Acciones",
            options: {
                filter: false,
                sort: false,
                customBodyRender: (value, tableMeta, updateValue) => (
                    <>
                        <Box display='flex'>
                            <DynamicTooltip  title="Ver Pre-Servicio" placement="top">
                                <IconButton color='primary' aria-label="ver" onClick={()=>onOpenVer(tableMeta.rowData[0])}>
                                    <ContentPasteGoIcon fontSize="medium" sx={{color: isDarkMode ? '#90caf9' : '#012a6b'}} />
                                </IconButton>
                            </DynamicTooltip>
                        </Box>
                    </>
                )
            }
        }
    ];
    useEffect(() => {
        actualizar(1, rowsPerPage)
        document.title = `Pre-Servicios`;
    }, [])

    return (
        <Box sx={{width:'100%',height: '100%',overflow:'auto', background: isDarkMode ? '#1a2332' : '#f5f5f5'}} className='side'>
            <Grid container p={4}>
                <Grid item xs={12} md={6} lg={6}>
                    <Typography className="font-bold" variant="h2" sx={{color: isDarkMode ? '#e0e0e0' : '#111827'}}>Pre-Servicios</Typography>
                </Grid>
                <Grid item xs={12} sx={{marginBottom: 15}}>
                    {loading ? (
                        <TableLoadingComponent />
                    ) : (
                        <TableBasePaginado
                            title='Resultados'
                            columns={columns}
                            data={items}
                            count={count}
                            page={page}
                            rowsPerPage={rowsPerPage}
                            onChangePage={onChangePage}
                            onChangeRowsPerPage={onChangeRowsPerPage}
                        />
                    )}
                </Grid>
            </Grid>
        </Box>
    )
}

export default PreServiciosScreen